/**
 *
 * 第三方公共类
 *
 */
function Common() {
	// 鉴权模式
	// 1、comein_channel + login
	// 2、comein_channel + comein_sign
	// 3、webNative
	// 4、miniprogram
	this.authMethod = null;

	this.comein_channel = '';

	this.comein_channel_pc = ''; // 券商研究所必填

	this.comein_sign = '';

	this.comein_auth = '';

	// 显示回到第三方券商列表的按钮
	this.showMenu = true;
	// 第三方按钮的样式、支持 btn、tab
	this.menuType = 'btn';

	// 第三方合作列表请求uc
	this.bolUc = true;

	// 显示进门App下载
	this.showAppDownload = false;

	this.instituteLogin = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0, 1],
		// 邮件登录类型，0 为中信证券，其余默认为 1
		emailLoginType: 1
	};

	this.instituteUser = {
		// 显示已购服务
		showBought: true
	};

	this.bindPhone = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0, 1]
	};

	// 路演详情
	this.roadshow = {};
}

export default Common;
